/**
 * @copyright Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React from "react";
import moment from "moment";

import { Col, Row } from "react-bootstrap";

import { CompanyDetailText } from "../Company";

import styled from "styled-components";

import SpendFormatNumber from "./SpendFormatNumber";

const CompanySpendReport = (props) => {
    const { company } = props;

    const currentYear = moment().year();

    return (
        <MainContainer>
            <Row style={{
                paddingBottom: 5,
                marginBottom: 20,
                marginLeft: 5,
                marginRight: 15,
                borderBottom: '2px solid #000',
            }}>
                <Col xs={6}>
                    <div style={{paddingTop: 15}}>
                        <CompanyDetailText fontWeight={'bold'} fontSize={18}>Activity</CompanyDetailText>
                    </div>
                </Col>
                <Col xs={2}>
                    <div style={{textAlign: 'center', paddingTop: 15}}>
                        <CompanyDetailText fontWeight={'bold'} fontSize={18}>{currentYear - 2}</CompanyDetailText>
                    </div>
                </Col>
                <Col xs={2}>
                    <div style={{textAlign: 'center', paddingTop: 15}}>
                        <CompanyDetailText fontWeight={'bold'} fontSize={18}>{currentYear - 1}</CompanyDetailText>
                    </div>
                </Col>
                <Col xs={2}>
                    <div style={{textAlign: 'center', paddingTop: 15}}>
                        <CompanyDetailText fontWeight={'bold'} fontSize={18}>{currentYear}</CompanyDetailText>
                    </div>
                </Col>
            </Row>
            <Row style={{
                paddingBottom: 5,
                marginBottom: 20,
                marginLeft: 5,
                marginRight: 15,
                borderBottom: '1px solid #000'
            }}>
                <Col xs={6}>
                    <CompanyDetailText fontSize={16}>Job Starts</CompanyDetailText>
                </Col>
                <Col xs={2}>
                    <div style={{textAlign: 'center'}}>
                        <CompanyDetailText fontSize={16}>
                            {company.activity?.jobStartsYearBeforeLast | 0}
                        </CompanyDetailText>
                    </div>
                </Col>
                <Col xs={2}>
                    <div style={{textAlign: 'center'}}>
                        <CompanyDetailText fontSize={16}>
                            {company.activity?.jobStartsLastYear | 0}
                        </CompanyDetailText>
                    </div>
                </Col>
                <Col xs={2}>
                    <div style={{textAlign: 'center'}}>
                        <CompanyDetailText fontSize={16}>
                            {company.activity?.jobStartsYearToDate | 0}
                        </CompanyDetailText>
                    </div>
                </Col>
            </Row>
            <Row style={{
                paddingBottom: 5,
                marginBottom: 20,
                marginLeft: 5,
                marginRight: 15,
                borderBottom: '1px solid #000'
            }}>
                <Col xs={6}>
                    <CompanyDetailText fontSize={16}>Permits Pulled</CompanyDetailText>
                </Col>
                <Col xs={2}>
                    <div style={{textAlign: 'center'}}>
                        <CompanyDetailText fontSize={16}>
                            {company.permits?.cntYearBeforeLast | 0}
                        </CompanyDetailText>
                    </div>
                </Col>
                <Col xs={2}>
                    <div style={{textAlign: 'center'}}>
                        <CompanyDetailText fontSize={16}>
                            {company.permits?.cntLastYear | 0}
                        </CompanyDetailText>
                    </div>
                </Col>
                <Col xs={2}>
                    <div style={{textAlign: 'center'}}>
                        <CompanyDetailText fontSize={16}>
                            {company.permits?.cntYearToDate | 0}
                        </CompanyDetailText>
                    </div>
                </Col>
            </Row>
            <Row style={{
                paddingBottom: 5,
                marginBottom: 20,
                marginLeft: 5,
                marginRight: 15,
                borderBottom: '1px solid #000'
            }}>
                <Col xs={6}>
                    <CompanyDetailText fontSize={16}>Material Spend</CompanyDetailText>
                </Col>
                <Col xs={2}>
                    <div style={{textAlign: 'center'}}>
                        <CompanyDetailText fontSize={16}>
                            {company.activity?.productCategorySpendYearBeforeLast | 0}
                        </CompanyDetailText>
                    </div>
                </Col>
                <Col xs={2}>
                    <div style={{textAlign: 'center'}}>
                        <CompanyDetailText fontSize={16}>
                            {company.activity?.productCategorySpendLastYear | 0}
                        </CompanyDetailText>
                    </div>
                </Col>
                <Col xs={2}>
                    <div style={{textAlign: 'center'}}>
                        <CompanyDetailText fontSize={16}>
                            {company.activity?.productCategorySpendYearToDate | 0}
                        </CompanyDetailText>
                    </div>
                </Col>
            </Row>
            <Row style={{
                paddingBottom: 5,
                marginBottom: 20,
                marginLeft: 5,
                marginRight: 15,
                borderBottom: '1px solid #000'
            }}>
                <Col xs={6}>
                    <CompanyDetailText fontSize={16}>Category Spend</CompanyDetailText>
                </Col>
                <Col xs={2}>
                    <div style={{textAlign: 'center'}}>
                        <CompanyDetailText fontSize={16}>
                            ${SpendFormatNumber(Math.ceil((company.activity?.categorySpendYearBeforeLast | 0) / 1000) * 1000)}
                        </CompanyDetailText>
                    </div>
                </Col>
                <Col xs={2}>
                    <div style={{textAlign: 'center'}}>
                        <CompanyDetailText fontSize={16}>
                            ${SpendFormatNumber(Math.ceil((company.activity?.categorySpendLastYear | 0) / 1000) * 1000)}
                        </CompanyDetailText>
                    </div>
                </Col>
                <Col xs={2}>
                    <div style={{textAlign: 'center'}}>
                        <CompanyDetailText fontSize={16}>
                            ${SpendFormatNumber(Math.ceil((company.activity?.categorySpendYearToDate | 0) / 1000) * 1000)}
                        </CompanyDetailText>
                    </div>
                </Col>
            </Row>
        </MainContainer>
    )
}

export default CompanySpendReport;

const MainContainer = styled.div`
    margin: 20px 20px 30px 20px;
`;
